var toCompactArray = function () {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    var _a;
    return (_a = []).concat.apply(_a, values).filter(Boolean);
};
export default toCompactArray;
